import ButtonLink from 'components/shared/ButtonLink.styled';
import { Heading1 } from 'components/shared/Typography';
import styled from 'styled-components';
import { color, container, fontSize, radius, screen, spacing } from 'theme';

export const StyledHero = styled.div`
  background-image: linear-gradient(
    180deg,
    ${color('cyan_900')} 18%,
    ${color('midnight_100')} 100%
  );
  padding: ${spacing('xl2')} ${spacing('md')} ${spacing('xl5')};

  @media (min-width: ${screen('lg')}) {
    padding: ${spacing('xl5')} ${spacing('md')} ${spacing('xl6')};
  }
`;

export const StyledImage = styled.img`
  border-radius: ${radius('md')};
  position: relative;
  overflow: hidden;
  max-width: 55rem;
  width: 100%;
`;

export const StyledHeroContainer = styled.div`
  max-width: ${container('xl')};
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing('xl2')};
`;

export const StyledHeroText = styled.div`
  max-width: 54rem;
  color: ${color('text_white')};
  text-align: center;
  line-height: 1.5;

  @media (min-width: ${screen('lg')}) {
    font-size: ${fontSize('xl')};
  }

  ${ButtonLink} {
    margin-top: ${spacing('lg')};
  }
`;

export const StyledHeroTitle = styled(Heading1)`
  margin-bottom: ${spacing('lg')};
`;
